import { createSelector } from "reselect";
import { isEmpty, forIn, isNull } from "lodash";

//EXTRACT THE PART OF THE STATE
const getData = state => {
  const userProfile = state.profile.info;
  const userPrivacy = state.profile.privacy;

  //if preference is empty return the default value
  if (isEmpty(userProfile)) {
    return "-";
  }

  if (isEmpty(userPrivacy)) {
    return "-";
  }
  //format the preference and return it
  if (isNull(userProfile.address)) {
    return "-";
  } else {
    if (userPrivacy.address) {
      if (userProfile.address.formatted_address) {
        return userProfile.address.formatted_address;
      } else {
        return "-";
      }
    } else {
      return "-";
    }
  }
};
//VERIFY IF THE JWT IS SET
const getMemberAddress = createSelector(getData, birthPlace => birthPlace);
export default getMemberAddress;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberAddress.js